import { Controller } from "stimulus";
import $ from "jquery";

// Loads the tuition row action-menu contents the first time the dropdown is opened.
// The frame placeholder carries the URL in `data-src` (not the turbo `src` attribute) so
// it does not auto-fetch; we set `src` on first toggle click to defer the per-row work.
export default class extends Controller {
  static targets = ["frame"];

  connect() {
    // The menu lives inside `.table-container.overflow-auto`, whose clip would cut off the
    // dropdown for the bottom rows. Initialize the Bootstrap dropdown with Popper's fixed
    // positioning so the menu is placed relative to the viewport and escapes the overflow clip.
    const toggle = this.element.querySelector('[data-toggle="dropdown"]');
    if (toggle) $(toggle).dropdown({ popperConfig: { positionFixed: true } });
  }

  load() {
    if (this.loaded || !this.hasFrameTarget) return;

    const src = this.frameTarget.dataset.src;
    if (!src) return;

    this.loaded = true;
    // Bootstrap/Popper positions the menu while it still shows the "Carregando…" placeholder.
    // Once the real items swap in, the menu grows and the cached position is stale (it overflows
    // and only realigns after a manual scroll). Re-run Popper once the frame finishes loading.
    this.frameTarget.addEventListener("turbo:frame-load", () => this.reposition(), { once: true });
    this.frameTarget.src = src;
  }

  reposition() {
    const toggle = this.element.querySelector('[data-toggle="dropdown"]');
    if (!toggle) return;

    try {
      $(toggle).dropdown("update");
    } catch (_e) {
      // Fallback: a resize event triggers Popper's update listener, the same recompute a
      // manual scroll causes.
      window.dispatchEvent(new Event("resize"));
    }
  }
}
